import { createFileRoute } from "@tanstack/react-router";
import { MembershipTransfers } from "@/components/MembershipTransfers";

function RouteComponent() {
  return <MembershipTransfers />;
}

export const Route = createFileRoute("/_authenticated/membership-transfers/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
